import { Star } from "lucide-react";

export const StarRating = ({ rating = 0, size = 14, className = "", showValue = false, count }) => {
  const full = Math.floor(rating);
  const half = rating - full >= 0.5;
  return (
    <span className={`inline-flex items-center gap-1 ${className}`} data-testid="star-rating">
      <span className="inline-flex">
        {[0, 1, 2, 3, 4].map((i) => {
          const filled = i < full || (i === full && half);
          return (
            <Star
              key={i}
              style={{ width: size, height: size }}
              className={filled ? "fill-gold text-gold" : "text-muted-foreground/40"}
            />
          );
        })}
      </span>
      {showValue && <span className="text-xs text-muted-foreground">{rating?.toFixed(1)}</span>}
      {count != null && <span className="text-xs text-muted-foreground">({count})</span>}
    </span>
  );
};
